export default {
    namespaced: true,

    state: {
        backend: null,
        community: null,
    },

    getters: {
        lastRouteBackend(state) {
            return state.backend;
        },

        lastRouteCommunity(state) {
            return state.community;
        },
    },

    mutations: {
        setLastRouteBackend(state, path) {
            state.backend = path;
        },

        setLastRouteCommunity(state, path) {
            state.community = path;
        },
    },
};